import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const STATUS_STYLES = {
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  processing: "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  awaiting_payment: "bg-slate-50 text-slate-700 border-slate-200",
  cancelled: "bg-slate-100 text-slate-600 border-slate-200",
};

const STATUS_KEY = {
  completed: "status_ready",
  processing: "status_processing",
  pending: "status_pending",
  failed: "status_failed",
  awaiting_payment: "status_awaiting_payment",
  cancelled: "status_failed",
};

export const StatusBadge = ({ status }) => {
  const { t } = useLanguage();
  const cls = STATUS_STYLES[status] || STATUS_STYLES.awaiting_payment;
  const labelKey = STATUS_KEY[status] || "status_awaiting_payment";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 text-xs font-medium border rounded-md ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      {t(labelKey)}
    </span>
  );
};

export default StatusBadge;
